module.exports = __webpack_public_path__ + "static/img/far1.22d5e080.png";